import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'
import { CSC_APPLE_PAY_GATEWAY, CSC_PAYMENTS_HOST } from '@/services/Configuration'
import { error, log } from '@/services/Log'
import type { ApplePayHandlerBuilderInput } from '../types'
import { withSessionCancelationHandling } from './withSessionCancelationHandling'

const rawSessionValidation = ({
  session,
  credentials,
  onAbort,
}: ApplePayHandlerBuilderInput) => (event: ApplePayJS.ApplePayValidateMerchantEvent) => {
  log('Apple Pay onvalidatemerchant: ', event)
  if (event.validationURL) {
    allPromisesWithRetries(() => [import('@csc/csc-sdk')])
      .then(([{ Payments }]) => (
        Payments({
          credentials,
          host: CSC_PAYMENTS_HOST,
        }).getApplePaySession({
          identity: credentials.identitySourceId,
          gatewayName: CSC_APPLE_PAY_GATEWAY,
          validationUrl: event.validationURL,
        })
      ))
      .then((merchantSession) => {
        log('Validate Merchant complete: ', merchantSession)
        session.completeMerchantValidation(merchantSession)
      })
      .catch(async (err) => {
        error('Error fetching merchant session', err)
        await onAbort()
      })
  }
}
export const handleApplePayMerchantValidation = withSessionCancelationHandling(rawSessionValidation)

export default handleApplePayMerchantValidation
